import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/bulk_contents/index.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/bulk_contents/show.vue') }

  static values = {
    bulkJobId: String,
    waiting: Boolean,
    status: String
  }

  connect() {
    super.connect({
      bulkJobId: this.bulkJobIdValue,
      waiting: this.waitingValue,
      status: this.statusValue
    })
  }
}
